import 'select2';
import { Options as Select2Options } from 'select2';

export class GroupSearch {
    private selectCallback: (data: any) => void = () => { };

    constructor(selector: string, props: {
        placeholder?: string,
        groupSearchUrl: string,
        paramName: string,
        multi?: boolean,
        selectWidth?: string,
        minInputLength?: number,
        dropdownAutoWidth?: boolean,
        minimumResultsForSearch?: number
    }) {
        const $select: JQuery<HTMLElement> = $(selector) as any;
        const searchUrl = props.groupSearchUrl;
        const paramName = props.paramName;
        const select2Options: Select2Options = {};
        select2Options.dropdownAutoWidth = props.dropdownAutoWidth || true;
        select2Options.minimumInputLength = props.minInputLength || 1;
        select2Options.width = props.selectWidth || 'auto';
        select2Options.minimumResultsForSearch = props.minimumResultsForSearch || 10;
        
        if(props.multi !== undefined && props.multi === true) {
            select2Options.multiple = true;
        }
        select2Options.placeholder = props.placeholder || 'Choose...';

        $select.select2({
            ...select2Options,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 600,
                data: function (params) {
                    var query = {};
                    query[paramName] = params.term;
                    return query;
                },
                processResults: function (data) {
                    var select2Format = [];
                    Object.keys(data).forEach(function (key) {
                        var jsonData = {};
                        
                        if (data[key].groupId === '') data[key].groupId = 'null';
                        jsonData['id'] = data[key].groupId;
                        jsonData['text'] = data[key].identifier;
                        select2Format.push(jsonData);
                    });
                    return {
                        results: select2Format
                    };
                }
            }
        }).select2('open').select2('close').on("select2:select", (e) => {
            const data = e.params.data;
            this.selectSuccess(data);
        }).on('select2:open', (e) => {
            // Code added to address focus issue created in version 3.3 of jQuery which steals focus away from Select2 element
            //@ts-ignore
            (list => list[list.length - 1])(document.querySelectorAll('.select2-container--open .select2-search__field')).focus();
        });
    }

    private selectSuccess(data: any) {
        // Run any success methods here before user provided callback
        this.selectCallback(data);
    }

    onSelect(callback: (data: any) => void): GroupSearch {
        this.selectCallback = callback;
        return this;
    }

}